/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { styled } from "styled-components";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import { SERVICES } from "../../components/Layout/Services";
import fetchData from "../../components/Layout/FetchData";
import SelectTag from "../../components/Layout/SelectTag";
import Button from "../../components/Layout/Button";
import BankTable from "../../components/Layout/Table/BankTable";
import BankModal from "../../components/Layout/Modal/BankModal";
import {
  del,
  get,
  post,
  put,
} from "../../components/Layout/ApiHandler/apihandler";
// import InputField from "../../components/Layout/InputField";
import OldInputField from "../../components/Layout/InputField";
import InputField from "../../components/Layout/fieldInput/InputField";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading";
import {
  OuterContainerStyles,
  SearchContainer,
  Title,
  CustomInputField,
} from "../../components/Layout/Typography";
import Loader from "../../components/Loader/Loader";
import EditIcon from "../../components/Svg/EditIcon";
import DeleteIcon from "../../components/Svg/DeleteIcon";
import { AlertStatus } from "../../contants";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import NoData from "../../components/NoData";
import Alert from "../../components/Alert/Alert";
import AutoCompleteDropdown from "../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";

const Text = styled.p`
  color: #484848;
  font-size: 16px;
  font-weight: 400;
  line-height: 125%;
  margin: 0 0;
`;

const FormWrapper = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const FieldWrapper = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: ${(props) => props.customGap || "10px"};
  align-self: stretch;

  // input: {
  //   border-radius: 3px;
  //   border: 0.5px solid #484848
  //   padding: 10px;
  // }
`;
// const CustomInputField = styled(Field)`
//   border-radius: 3px;
//   border: 0.5px solid #484848;
//   padding: 10px;
// `;
const NoteContainer = styled.div`
  padding: 0 24px 24px 24px;
`;
const NoteText = styled.p`
  color: #6d6d6d;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0;
`;
const NoteListItem = styled.li`
  color: #6d6d6d;
  font-size: 14px;
  font-weight: 400;
  margin: 0 0;
`;
const ErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-size: 14px;
  padding-left: 24px;
`;

const BankDetailsSchema = Yup.object().shape({
  branchName: Yup.string().required("Branch is required"),
  ifscCode: Yup.string().required("IFSC Code is required"),
  accountNumber: Yup.number().required("Account Number is required"),
  defaultForCa: Yup.boolean().required("You must accept defaultForCa"),
});

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

function DepositBankDetails() {
  const TITLE = "Collection Deposit Bank - BSG ContributionAdmin";
  const [bankData, setBankData] = useState({});
  const [banksData, setBanksData] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [banksIds, setBanksIds] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bankBranchData, setbankBranchData] = useState([]);
  const [bankIndId, setBankIndId] = useState("");
  const [branchIndId, setBranchIndId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [individualBankData, setIndividualBankData] = useState([]);
  const [bankBranchesDataArray, setBankBranchesDataArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [openAlert, setOpenAlert] = useState(false);
  const [intitialBankValues, setInitialBankValues] = useState({});
  const [branchName, setBranchName] = useState("");
  const [ifscCode, setIfsc] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [defaultContribution, setDefaultContribution] = useState("");

  const handleAlertClose = () => {
    setOpenAlert(false);
  };
  const handleBankSelect = (bankId) => {
    setSelectedBankId(bankId);
  };
  const handleBranchName = (value) => {
    setBranchName(value);
  };
  const handleIfsc = (value) => {
    setIfsc(value);
  };

  const handleAccountNumber = (value) => {
    setAccountNumber(value);
  };
  const handleDefaultContributionChange = (event) => {
    const { value } = event.target;
    setDefaultContribution(value);
  };

  const fetchBankData = useCallback(async () => {
    // const url = "http://43.205.5.55:8081/contribution/api/banks";
    const url = `${SERVICES.BANKS_DETAILS}`;
    await fetchData(url, setBankData, setIsLoading);
  }, []);

  // const openModal = () => {
  //   setIsModalOpen(true);
  // };

  const getBankBranchDeatils = async (bankId, branchId) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankId}/branches/${branchId}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        return data.data;
      }
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  const handleBankSubmit = async (bankId, branchId) => {
    setBankIndId(bankId);
    setBranchIndId(branchId);

    try {
      const initialValues = await getBankBranchDeatils(bankId, branchId);
      setInitialBankValues(initialValues);
      setIsModalOpen(true);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleDeleteAlert = (bankId, branchId) => {
    setBankIndId(bankId);
    setBranchIndId(branchId);
    setOpenAlert(true);
  };

  useEffect(() => {
    fetchBankData();
  }, [fetchBankData]);

  // console.log(bankData);
  useEffect(() => {
    if (bankData.content) {
      setBanksData(bankData.content);
    }
  }, [bankData.content]);

  // useEffect(() => {
  //   if (banksData.length > 0) {
  //     // Extract the city IDs from banksData and update the state
  //     const ids = banksData.map((el) => el.id);
  //     setBanksIds(ids);
  //   }
  //   handleFetchBranches();
  // }, [banksData]);

  // console.log(banksIds);

  const fetchBranchesForBankId = async (bankId) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankId}/branches`;
      const response = await get(url);
      const data = await response.json();
      // console.log(data);
      setbankBranchData(data);
      return data;
    } catch (error) {
      Sentry.captureException(error);
      return [];
    }
  };

  const handleDeleteBank = async (bankId, branchId) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankId}/branches/${branchId}`;
      const response = await del(url);
      if (response.ok) {
        toast.show("Bank Deleted Successfully", AlertStatus.SUCCESS);
        await handleFetchBranches();
        handleAlertClose();
      } else {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  const validateBankDetails = () => {
    if (!selectedBankId) {
      toast.show("Please Select Bank", AlertStatus.ERROR);
      return false;
    }
    if (!branchName) {
      toast.show("Please Enter Branch Name", AlertStatus.ERROR);
      return false;
    }
    if (!ifscCode) {
      toast.show("Please Enter IFSC Code", AlertStatus.ERROR);
      return false;
    }
    if (!accountNumber) {
      toast.show("Please Enter Account Number", AlertStatus.ERROR);
      return false;
    }
    return true;
  };
  const resetForm = () => {
    setSelectedBankId("");
    setBranchName("");
    setIfsc("");
    setAccountNumber("");
    setDefaultContribution("");
  };

  const handleSubmitForm = async () => {
    if (!validateBankDetails()) {
      return;
    }
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${selectedBankId}/branches`;
      const data = {
        branchName,
        ifscCode,
        accountNumber,
        defaultForCa: defaultContribution || false,
      };
      const response = await post(url, data);
      if (response.ok) {
        toast.show("Bank Details Added Successfully", AlertStatus.SUCCESS);
        // console.log("Form submitted successfully");
        resetForm();
        await handleFetchBranches();
      } else {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
        console.error("Failed to submit the form");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleModalSubmit = async (values) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankIndId}/branches/${branchIndId}`;
      const response = await put(url, values);
      if (response.ok) {
        toast.show("Bank Details Updated Successfully", AlertStatus.SUCCESS);
        // console.log("Form submitted successfully");
        await handleFetchBranches();
        closeModal();
      } else {
        console.error("Failed to submit the form");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleSearch = async () => {
    // console.log(searchText);
    if (searchText.trim() === "") {
      handleFetchBranches();
      return;
    }
    // console.log(bankBranchesDataArray);
    // const foundBank = bankBranchesDataArray.find(
    //   (bank) => bank.bank.bankName === searchText.trim(),
    // );
    const foundBank = bankBranchesDataArray.find((el) =>
      el.bank.bankName.toLowerCase().includes(searchText.trim().toLowerCase()),
    );
    // console.log(foundBank);

    if (foundBank) {
      try {
        const url = `${SERVICES.BANKS_DETAILS}/${foundBank.bank.id}/branches/${foundBank.id}`;
        const response = await get(url);

        if (response && response.ok) {
          const data = await response.json();
          const BankDataArray = [data.data];
          setIndividualBankData(BankDataArray);
        } else {
          console.error("Failed to fetch city data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    } else {
      setSelectedBankId(null);
      toast.show("Bank not found.", AlertStatus.ERROR);
    }
  };

  const handleFetchBranches = async () => {
    const updatedBankBranchesDataArray = [];

    for (const bankId of banksIds) {
      const branches = await fetchBranchesForBankId(bankId);
      // console.log(`Branches for bankId ${bankId}:`, branches);
      updatedBankBranchesDataArray.push(...branches.data);
    }
    setBankBranchesDataArray(updatedBankBranchesDataArray);
  };

  useEffect(() => {
    if (bankBranchesDataArray) {
      const updatedTableData = bankBranchesDataArray.map((item, index) => {
        return {
          id: item.id,
          column1: index + 1,
          column2: item.bank.bankName,
          column3: item.branchName,
          column4: item.ifscCode,
          column5: item.accountNumber,
          column6: item.defaultForCa ? "Yes" : "No",
          column7: (
            <div
              style={{ display: "flex", gap: "25px", justifyContent: "center" }}
            >
              <EditIcon
                onClick={() => handleBankSubmit(item.bank.id, item.id)}
                style={{ cursor: "pointer" }}
              />
              <DeleteIcon
                // onClick={() => handleDeleteBank(item.bank.id, item.id)}
                onClick={() => handleDeleteAlert(item.bank.id, item.id)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [bankBranchesDataArray]);

  useEffect(() => {
    if (individualBankData.length > 0) {
      const updatedTableData = individualBankData.map((item, index) => {
        return {
          id: item.id,
          column1: index + 1,
          column2: item.bank.bankName,
          column3: item.branchName,
          column4: item.ifscCode,
          column5: item.accountNumber,
          column6: item.defaultForCa ? "Yes" : "No",
          column7: (
            <div
              style={{ display: "flex", gap: "25px", justifyContent: "center" }}
            >
              <EditIcon
                onClick={() => handleBankSubmit(item.bank.id, item.id)}
                style={{ cursor: "pointer" }}
              />
              <DeleteIcon
                // onClick={() => handleDeleteBank(item.bank.id, item.id)}
                onClick={() => handleDeleteAlert(item.bank.id, item.id)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [individualBankData]);
  useEffect(() => {
    if (banksData.length > 0) {
      // Extract the city IDs from banksData and update the state
      const ids = banksData.map((el) => el.id);
      setBanksIds(ids);
    }
    // handleFetchBranches();
  }, [banksData]);
  useEffect(() => {
    handleFetchBranches();
  }, [banksIds]);
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  // console.log("line 429", defaultContribution);

  const tableHeaders = [
    "S. No.",
    "BSG Bank Name",
    "Branch",
    "IFSC Code",
    "A/C No.",
    "Del For CA",
    "Action",
  ];
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      {/* <Header>BSG Bank Details</Header> */}
      <Heading title="Collection Deposit Bank" />
      <OuterContainerStyles>
        <Title>Existing Bank</Title>
        <SearchContainer>
          <OldInputField
            onChange={handleInputChange}
            placeholder="Bank Name"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <Button onClick={handleSearch}>Search</Button>
          <Btn onClick={handleFetchBranches}>View All</Btn>
        </SearchContainer>
        {tableData?.length ? (
          <BankTable data={tableData} headers={tableHeaders} />
        ) : (
          !tableData?.length && isLoading === false && <NoData />
        )}
        <NoteContainer>
          <NoteText>Note:</NoteText>
          <ul>
            <NoteListItem>
              BSG Bank tagged as default for Contribution Admin can be removed
              by marking different bank as default for Contribution Admin
            </NoteListItem>
            <NoteListItem>
              Details of BSG Bank tagged for online Contribution can not be
              updated
            </NoteListItem>
          </ul>
        </NoteContainer>
      </OuterContainerStyles>
      <OuterContainerStyles marginTop="24px">
        {/* <Formik
          initialValues={{
            branchName: "",
            ifscCode: "",
            accountNumber: "",
            defaultForCa: false,
          }}
          validationSchema={BankDetailsSchema}
          onSubmit={handleSubmitForm}
        >
          {(formik) => (
            <Form>
              <FormWrapper>
                <Title style={{ padding: "0 0 20px 0", margin: "0 0" }}>
                  BSG Bank Details
                </Title>
                <FieldWrapper customGap="196px">
                  <Text>BSG Bank </Text>
                  <SelectTag
                    banksData={banksData}
                    label="Select Bank"
                    onChange={handleBankSelect}
                  />
                </FieldWrapper>
                <ErrorMessageContainer>
                  <ErrorMessage name="city" component="div" />
                </ErrorMessageContainer>
                <FieldWrapper customGap="216px">
                  <Text>Branch</Text>
                  <CustomInputField
                    type="text"
                    name="branchName"
                    placeholder="Branch"
                  />
                </FieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.branchName ? (
                    <div>{formik.errors.branchName}</div>
                  ) : null}
                </ErrorMessageContainer>
                <FieldWrapper customGap="194px">
                  <Text>IFSC Code</Text>
                  <CustomInputField
                    type="text"
                    name="ifscCode"
                    placeholder="IFSC Code"
                  />
                </FieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.ifscCode ? (
                    <div>{formik.errors.ifscCode}</div>
                  ) : null}
                </ErrorMessageContainer>
                <FieldWrapper customGap="142px">
                  <Text>Account Number</Text>
                  <CustomInputField
                    type="text"
                    name="accountNumber"
                    placeholder="Account Number"
                  />
                </FieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.accountNumber ? (
                    <div>{formik.errors.accountNumber}</div>
                  ) : null}
                </ErrorMessageContainer>
                <FieldWrapper customGap="30px">
                  <Text>Default for Contribution Admin</Text>
                  <div>
                    <label>
                      <Field type="radio" name="defaultForCa" value="true" />
                      Yes
                    </label>
                    <label>
                      <Field type="radio" name="defaultForCa" value="false" />
                      No
                    </label>
                  </div>
                </FieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.defaultForCa ? (
                    <div>{formik.errors.defaultForCa}</div>
                  ) : null}
                </ErrorMessageContainer>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "24px",
                    width: "100%",
                  }}
                >
                  <div style={{ flex: 1 }} />
                  <Button
                    cancel
                    type="button"
                    onClick={() => {
                      formik.resetForm();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button type="button" onClick={formik.handleSubmit}>
                    Submit
                  </Button>
                </div>
              </FormWrapper>
            </Form>
          )}
        </Formik> */}
        <OuterCard>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            BSG Bank Details
          </OuterCardHeading>
          <FieldsDiv>
            {/* <SelectTag
              banksData={banksData}
              label="Select Bank"
              onChange={handleBankSelect}
            /> */}
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.bankName}
              options={getOptions(banksData, "id")}
              label="Select Bank"
              // name="paymentMethods"
              value={selectedBankId}
              onChange={(selectedValue) => {
                // setSelectedBank(selectedValue?.value);
                handleBankSelect(selectedValue?.value);
              }}
              inputProps={{
                required: true,
              }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <InputField
              label="Branch"
              required
              value={branchName}
              onChange={(event) => {
                const { value } = event.target;
                handleBranchName(value);
              }}
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <InputField
              label="IFSC"
              required
              value={ifscCode}
              onChange={(event) => {
                const { value } = event.target;
                handleIfsc(value);
              }}
              style={{ width: "350px" }}
            />
            <InputField
              label="Account Number"
              required
              value={accountNumber}
              onChange={(event) => {
                const { value } = event.target;
                handleAccountNumber(value);
              }}
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <FormControl>
              <FormLabel>Default for Contribution</FormLabel>
              <RadioGroup
                row
                value={defaultContribution}
                onChange={handleDefaultContributionChange}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </FieldsDiv>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
              width: "100%",
            }}
          >
            <div style={{ flex: 1 }} />
            <Button
              cancel
              type="button"
              onClick={() => {
                resetForm();
              }}
              // onClick={() => {
              //   formik.resetForm();
              // }}
            >
              Cancel
            </Button>
            <Button type="button" onClick={handleSubmitForm}>
              Submit
            </Button>
          </div>
        </OuterCard>
      </OuterContainerStyles>
      <BankModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={handleModalSubmit}
        initialValues={{
          branchName: intitialBankValues.branchName,
          ifscCode: intitialBankValues.ifscCode,
          accountNumber: intitialBankValues.accountNumber,
          defaultForCa: intitialBankValues.defaultForCa,
        }}
      />
      <Alert
        open={openAlert}
        onClose={handleAlertClose}
        onSubmit={() => handleDeleteBank(bankIndId, branchIndId)}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default DepositBankDetails;

const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;

const OuterCard = styled.div`
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c5c5d1;
  background: #f5f5f5;
`;

const OuterCardHeading = styled.p`
  margin: 0;
  color: #000;
  //   font-family: Noto Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const FieldsDiv = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 146px;
  align-self: stretch;
`;
